module.exports = __webpack_public_path__ + "img/rugby4.e2248941.jpg";